module.exports = __webpack_public_path__ + "static/media/icon-atividades.90862685.svg";